<template>
  <div>
    <div class="row mb-2">
      <div class="col-12">
        <div class="row my-3 horizontal-nav">
          <div class="mx-3">
            <router-link :to="{ name: 'transactions' }" class="px-4">
              Transakcie
            </router-link>
          </div>
          <div class="mr-3">
            <router-link :to="{ name: 'trades' }" class="px-4">
              Obchody
            </router-link>
          </div>
          <div class="mr-3">
            <router-link :to="{ name: 'conversions' }" class="px-4">
              Konverzie
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3">
        <div class="card">
          <div class="card-body mt-2 p-4">
            <transactions-date-picker class="mb-3" />
            <div class="color-yellow mb-2">Stratégia:</div>
            <transactions-strategy-picker />
            <div class="color-yellow mt-3 mb-2">Suma:</div>
            <transactions-value-picker />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-9">
        <router-view
          :portfolio="currentPortfolio ? currentPortfolio.portfolio : null"
          :from="from"
          :to="to"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TransactionsDatePicker from "../../../components/TransactionsDatePicker";
import TransactionsValuePicker from "../../../components/TransactionsValuePicker";
import TransactionsStrategyPicker from "../../../components/TransactionsStrategyPicker";

export default {
  name: "Transactions",
  components: {
    TransactionsDatePicker,
    TransactionsValuePicker,
    TransactionsStrategyPicker
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    currentPortfolio() {
      return this.$store.state.portfolio.selected;
    }
  },
  data() {
    return {
      from: null,
      to: null
    };
  }
};
</script>

<style lang="scss">
.transactions-filter {
  .form-control {
    height: 35px;
    font-size: 14px;
  }
}
</style>
